
{
  "labels": {
    "showing": "Showing {currentRange} of {total}",
    "previous": "Previous",
    "next": "Next"
  }
}
